import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconPumps = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 40 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0 36V24H3C2.36 22.12 2 20.1 2 18C2 8.06 10.06 0 20 0H40V12H37C37.64 13.88 38 15.9 38 18C38 27.94 29.94 36 20 36H0ZM6 18C6 20.56 6.68 22.94 7.88 25L14.8 21C14.3 20.12 14 19.1 14 18C14 16.7 14.42 15.5 15.12 14.52L8.6 9.86C7 12.16 6 15 6 18ZM20 32C25.18 32 29.7 29.18 32.12 25L25.2 21C24.16 22.8 22.22 24 20 24H19.42L18.66 31.94L20 32ZM20 12C22.42 12 24.52 13.44 25.46 15.52L32.74 12.2C30.54 7.36 25.66 4 20 4V12ZM20 16C18.9 16 18 16.9 18 18C18 19.1 18.9 20 20 20C21.1 20 22 19.1 22 18C22 16.9 21.1 16 20 16Z",
		fill: "currentColor"
	})
});
export default SvgIconPumps;
